import { useAuth } from './AuthProvider';

export function useHasPermission(permission: string): boolean {
  const { user } = useAuth();
  return user?.permissions?.includes(permission) ?? false;
}

export function useHasAnyPermission(permissions: readonly string[]): boolean {
  const { user } = useAuth();
  if (!user?.permissions) return false;
  return permissions.some((p) => user.permissions.includes(p));
}
